export const PHASES = "/api/cursus/:param/phases"
export const PHASE = "/api/cursus/:param/phases/:phaseParam"

export const CONTRACT = "/api/partnerships/:param/contracts/:contractParam"
